<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Tasks</h5>
        <div class="dropdown pull-right" v-if="user.admin || user.roles.length > 1">
          <button
          id="request-task" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
          class="btn btn-xs btn-primary pull-right"
        ><i class="fa fa-tasks"></i> Request New Task</button>
          <ul class="dropdown-menu" aria-labelledby="request-task">
            <li v-for="role in ['content', 'fix', 'build', 'links', 'tech']" :key="role" v-if="user.admin || user.roles.includes(role)">
              <a class="dropdown-item" @click="requestTask(role)"><i :class="icons[role] + ' m-r-sm'"></i> {{ ucFirst(role) }}</a>
            </li>
          </ul>

        </div>
        <button class="btn btn-xs btn-primary pull-right" @click="requestTask(user.roles[0])" v-else><i class="fa fa-tasks"></i> Request New {{ user.roles[0] }} Task</button>
      </div>
      <div class="ibox-content col-lg-12">
        <filters></filters>
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Tasks/Filters'
import List from './Tasks/List'
import axios from 'axios'
import { mapGetters } from 'vuex'
import { String } from '../../../mixins/helperMixin'

export default {
  data () {
    return {
      icons: {
        content: 'fa fa-file',
        fix: 'fas fa-tools',
        build: 'fas fa-hammer',
        links: 'fa fa-link',
        tech: 'fas fa-robot'
      }
    }
  },
  mounted () {
    document.title = 'Tasks :: Maintenance :: PBN360 by Aphex Media'
  },
  components: {
    filters: Filters,
    list: List
  },
  mixins: [String],
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    requestTask (type = 'content') {
      axios.post('/maintenance/task/request', {
        type: type
      })
        .then(r => {
          this.$toastr.success('New task has been assigned to you', 'Here you go')
          this.$router.push(`/maintenance/task/${r.data.task.id}`)
        })
        .catch(e => {
          this.$toastr.error(e.response.data.error.msg, 'I\'m so sorry')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Tasks.vue